module.exports = __webpack_public_path__ + "static/media/aidevcon.2b366431.jpg";